/**
 * A dialog that sits over the boxes: antd's Modal, react-bootstrap's (the Confirm context).
 * antd's Drawer is a `role="dialog"` too, but the object-tree drawer is a side panel beside
 * the boxes, and its label chips and tree nodes keep focus after a click.
 */
const MODAL_DIALOG = '[role="dialog"]:not(.ant-drawer-section)';

/**
 * Whether a key pressed on `element` comes from inside a modal dialog, so a shortcut that
 * changes the boxes hidden under it (paste, undo) must leave it alone.
 *
 * @param {EventTarget|null} element the event target or the focused element
 * @returns {boolean}
 */
export const isInsideModal = element => Boolean(element?.closest?.(MODAL_DIALOG));
